import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { DateTimeColumnConfigDto } from '../../../types';

interface DateTimeColumnConfigEditorProps {
  config: DateTimeColumnConfigDto;
  onTypeChange: (config: DateTimeColumnConfigDto) => void;
}

const DATETIME_FORMATS = [
  { formatLabel: 'dd/mm/yyyy HH:mm:ss', value: 'dd/MM/yyyy HH:mm:ss' },
  { formatLabel: 'dd/mm/yyyy hh:mm', value: 'dd/MM/yyyy HH:mm' },
];

export function DateTimeColumnConfigEditor({
  config,
  onTypeChange,
}: DateTimeColumnConfigEditorProps) {
  const { $t } = useIntl();

  const formatsWithLabels = useMemo(() => {
    const now = DateTime.now();
    return DATETIME_FORMATS.map((format) => ({
      ...format,
      label: `${format.formatLabel} (${now.toFormat(format.value)})`,
    }));
  }, []);

  const handleFormatChange = (format: string) => {
    onTypeChange({
      ...config,
      format,
      timezone: config.timezone || null,
    });
  };

  const handleTimezoneChange = (timezone: string) => {
    onTypeChange({
      ...config,
      timezone: timezone || null,
    });
  };

  return (
    <Box marginTop={2} display="flex" flexDirection="column" gap={2}>
      <Box>
        <FormControl size="small">
          <Typography variant="caption" color="text.secondary" gutterBottom>
            {$t({
              id: 'audit.reportDefinitionEditor.columnType.datetime.format',
              defaultMessage: 'Formato de fecha y hora',
            })}
          </Typography>
          <Select
            value={config.format}
            onChange={(e) => handleFormatChange(e.target.value)}
            required
          >
            {formatsWithLabels.map((format) => (
              <MenuItem key={format.value} value={format.value}>
                {format.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {/* <TextField
        fullWidth
        size="small"
        label={$t({
          id: 'audit.reportDefinitionEditor.columnType.datetime.timezone',
          defaultMessage: 'Zona horaria (opcional)',
        })}
        value={config.timezone || ''}
        onChange={(e) => handleTimezoneChange(e.target.value)}
        placeholder={$t({
          id: 'audit.reportDefinitionEditor.columnType.datetime.timezonePlaceholder',
          defaultMessage: 'Ej: UTC, America/New_York',
        })}
      /> */}
    </Box>
  );
}
